<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "AppV1",
  mounted() {
    import("../assets/css/sb-admin-2.css");
    import("../assets/css/bootstrap-custom.css");
    import("../assets/css/styles.css");
  },
};
</script>
